import React from "react";
import { Button, Container, FormControl, InputLabel, MenuItem, Select, CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import CopyLinkToClipboard from  "../CopyLinkToClipboard";
import useGenerateUrlController from "../useGenerateUrlController";
import { NOW_READY_URL } from "../constants";
import "../style.css";

export default ({ id }) => {
    const {
        handleGetOptionSelected,
        handleAutoCompleteOnChange,
        handleAutocompleteInputChange,
        urlProps,
        projectsProps,
        destinationsProps,
    } = useGenerateUrlController(id, NOW_READY_URL);
    
    const { appUrl, isUrlCopied, setIsUrlCopied, isGenerateUrlButtonDisabled, generateUrl } = urlProps;
    const { projectInputLabel, projectLabelWidth, projects, selectedProject,  setSelectedProject, loadingProjects } = projectsProps;
    const { destinations, loadingDestinations, isDestinationsInputOpen,  setIsDestinationsInputOpen, destinationsInputValue } = destinationsProps;

    /** Material UI Autocomplete handle functions */ 
    function renderInputField(params) {
        return (
            <TextField
                {...params}
                label="Destinations"
                variant="outlined"
                InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                        <>
                            {loadingDestinations ? <CircularProgress size={20} /> : null}
                            {params.InputProps.endAdornment}
                        </>
                    ),
                }}
            />
        );
    };

    return (
        <div className="curbside-app-url">
            <Container maxWidth="xl" className="white-card main-container">
                <h5 className="title">Generate URL for Now Ready Demo App</h5>
                <div className="columns-wrapper">
                    <div>
                        <p>
                            Generates a URL that can be used to demonstrate the link between
                            Now Ready and Hello Screens.
                        </p>
                        <div className="important-notes">
                            <h5>Important</h5>
                            <ul>
                                <li>Please ensure that <b>Now Ready branding configuration has been set up</b> for the target project, and the <b>Hello Screens feature is enabled</b> for this account</li><br />
                                <li>At least one Destination must be created for the selected Project to generate a URL</li><br />
                                <li>Only shows the first 100 Projects of this account</li><br />
                                <li>Using this URL will replace any previous link of Hello Screens to a destination, linking it to the target demo destination. To preserve your current linking please use a different browser when opening the demo app.</li><br />
                                <li>The Hello Screens registration code has an expiry time of 7 days so this link will only be valid for 7 days</li><br />
                                <li>The app will not function correctly if open in multiple tabs. Please only open in 1 tab at a time</li><br />
                            </ul>
                        </div>
                    </div>

                    <div className="url-form-wrapper">
                        <div className="select-inputs-wrapper">
                            <FormControl variant="outlined" className="select-input">
                                <InputLabel style={{textAlign: "center"}} ref={projectInputLabel} id="project-input-label">
                                    {!loadingProjects ? "Project" : <CircularProgress size={20} />}
                                </InputLabel>
                                <Select
                                    value={selectedProject}
                                    onChange={(e) => setSelectedProject(e.target.value)}
                                    labelWidth={projectLabelWidth}
                                    width={200}
                                    disabled={loadingProjects || !(projects && projects.length)}
                                >
                                    {projects.map((project) => (
                                        <MenuItem key={project._id} value={project}>
                                            {project.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl variant="outlined" className="select-input">
                                <Autocomplete
                                    open={isDestinationsInputOpen}
                                    onOpen={() => setIsDestinationsInputOpen(true)}
                                    onClose={() => setIsDestinationsInputOpen(false)}
                                    getOptionSelected={handleGetOptionSelected}
                                    getOptionLabel={(destination) => destination.name}
                                    options={destinations}
                                    loading={loadingDestinations}
                                    disabled={!selectedProject || loadingDestinations}
                                    inputValue={destinationsInputValue}
                                    onChange={handleAutoCompleteOnChange}
                                    onInputChange={handleAutocompleteInputChange}
                                    renderInput={renderInputField}
                                />
                            </FormControl>
                        </div>
                        <div className="generate-url-button-wrapper">
                            <Button
                                variant="contained"
                                color="primary"
                                disableElevation
                                onClick={generateUrl}
                                disabled={isGenerateUrlButtonDisabled()}
                            >
                                Generate URL
                            </Button>
                        </div>
                        <CopyLinkToClipboard url={appUrl} setIsUrlCopied={setIsUrlCopied} isUrlCopied={isUrlCopied} />
                    </div>
                </div>
            </Container>
        </div>
    );
};